import React from "react";

function SecurityEHero() {
  return (
    <>
      <div
        className="banner-style-two-area bg-theme shadow theme text-light bg-cover"
        style={{
          background:
            "url(assets/img/bg/white_label_crypto_exchange_image.jpg)",
        }}
      >
        <div className="container">
          <div className="row align-center">
            <div className="col-xl-9 col-lg-8">
              <div className="banner-two-content">
                <h2 className="split-text-right split-text-in-right">
                  Security Token
                </h2>
                <div className="">
                  <h2 className="split-text-right split-text-in-right">
                    Exchange Development
                  </h2>
                  <p className="fade-up-anim">
                    At Xeer Technology, we specialize in developing robust
                    security token trading exchanges that empower businesses and
                    investors to leverage the benefits of blockchain technology.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SecurityEHero;
